// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Gw-z","expressButtonContainerWithPayPal":"Hw-z","expressButton":"Iw-z","or":"Jw-z"};